import ProjectSupplier from '@/models/ProjectSupplier';
import ProjectSupplierService from '@/services/ProjectSupplierService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useProjectSupplierStore = defineStore('projectSupplier', {
  state: () => ({}),

  getters: {
    models: () => useRepo(ProjectSupplier),
  },

  actions: {
    async index(projectId: Id) {
      const [data, error] = await ProjectSupplierService.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async show(id: Id) {
      const [data, error] = await ProjectSupplierService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async createProjectSupplier(projectId: Id, request: ApiRequests['api.v1.project-supplier.store']) {
      const [data, error] = await ProjectSupplierService.create(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateProjectSupplier(id: Id, request: ApiRequests['api.v1.project-supplier.update']) {
      const [data, error] = await ProjectSupplierService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteProjectSupplier(id: Id) {
      const [data, error] = await ProjectSupplierService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },
  },
});
